// AIDEV-NOTE: temporal-bootstrap; installs the Temporal polyfill on globalThis WITHOUT going
// through `temporal-polyfill/global`. That entry also replaces `Intl.DateTimeFormat` with a
// wrapper built from the *own* prototype descriptors of whatever `Intl.DateTimeFormat` it
// finds at load time. Timezone-spoofing extensions and anti-detect / scraping browsers swap
// in their own wrapper before any page script runs; a wrapper has no own `format*`
// descriptors, so the polyfill's replacement had none either and every
// `Intl.DateTimeFormat(...).formatToParts` in the page — the shim's own `new Date` included —
// threw "formatToParts is not a function". The site never booted for those visitors
// (production error spike, 2026-09). Nothing in this app formats a Temporal object through
// `Intl.DateTimeFormat` (every formatter in @/shared/lib/core takes a `Date`, and Temporal's
// own `toLocaleString` does not depend on the global patch), so install only `Temporal` and
// touch nothing else — not `Intl`, and not `Date.prototype` either (`Date` is the other global
// those shims replace, so a `toTemporalInstant` patch would land on the shim's prototype;
// call sites use `Temporal.Instant.fromEpochMilliseconds(date.getTime())` instead).
// Guarded by `src/app/polyfills/__tests__`, the intl-prewrap smoke test, and the
// intl-datetimeformat-guardrail in eslint.config.js.
/// <reference types="temporal-polyfill/global" />
import { Temporal } from 'temporal-polyfill/impl'

// Same descriptor shape `temporal-polyfill/global` uses (configurable + writable): a later
// script can still override it, and re-evaluating this module is idempotent.
Object.defineProperty(globalThis, 'Temporal', {
  value: Temporal,
  configurable: true,
  writable: true,
})
